export const ThemeNames = {
	codan: 'Codan-theme',
	almbrand: 'Almbrand-theme',
	privatsikring: 'Privatsikring-theme',
} as const;

export type ThemeName = (typeof ThemeNames)[keyof typeof ThemeNames];

const themeNameValues = Object.values(ThemeNames) as ThemeName[];

export const isThemeName = (themeName?: string | null): themeName is ThemeName => {
	return typeof themeName === 'string' && themeNameValues.includes(themeName as ThemeName);
};
